import * as photosModule from '@/store/photos/photosModule'

export const state = Object.assign({}, photosModule.defaults())

export default {
  namespaced: true,
  state,
  mutations: photosModule.mutations,
  actions: photosModule.actions,
  getters: photosModule.getters
}



// WEBPACK FOOTER //
// ./src/store/units/unitPhotosModule.js